const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"76e793b71e385de8b5ecc2fb38f996e8b21ac2a8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["moodlight-app@moodlight"]={id:"76e793b71e385de8b5ecc2fb38f996e8b21ac2a8"};
      